import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isValidNumber',
})
export class IsValidNumberPipe implements PipeTransform {
  transform(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(parseFloat(value));
  }
}
